/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GroupedDateIntervals } from './grouped-date-intervals';


export interface GetMiningRewardChartRequest { 
    accountId?: string | null;
    startDate: string;
    interval: GroupedDateIntervals;
    miningProductId: number;
}



